import React from 'react';
import { adoptionTrendStats, averageProviderCount, driverStats, strategicGoalStats } from '../constants';
import { ReactComponent as LightbulbIcon } from 'static/img/lightbulb.svg';

const renderModalShell = (title, description, content) => (
  <div className="information-modal">
    <div className="information-modal__icon">
      <LightbulbIcon />
    </div>
    <h2>{title}</h2>
    {description && <p>{description}</p>}
    {content}
  </div>
);

const renderBenchmarkStats = (items, isHighlighted = () => false) => (
  <div className="benchmark-stats">
    {items.map((item) => {
      const highlighted = isHighlighted(item);
      return (
        <div key={item.label} className={`benchmark-row${highlighted ? ' is-highlighted' : ''}`}>
          <span className="benchmark-row__label">{item.label}</span>
          <div className="benchmark-row__bar" aria-hidden="true">
            <div className={`benchmark-row__bar-fill${highlighted ? ' is-highlighted' : ''}`} style={{ width: `${item.value}%` }} />
          </div>
          <span className="benchmark-row__value">{item.value}%</span>
        </div>
      );
    })}
  </div>
);

const BenchmarkModal = ({ isOpen, modalType, formData, sliderValue }) => {
  const renderers = {
    driversAnalysis: () =>
      renderModalShell(
        'Industry Drivers Analysis',
        "Here's how your priorities compare to industry averages:",
        renderBenchmarkStats(driverStats, (item) => formData?.factors?.includes(item.key))
      ),
    geographyInsights: () =>
      renderModalShell(
        'Local Infrastructure Considerations',
        'Regional variations in multicloud priorities reflect local business environments and regulatory requirements that must be navigated:',
        <ul className="modal-list">
          <li>
            <strong>Europe:</strong> GDPR compliance drives 56% to prioritize security
          </li>
          <li>
            <strong>India:</strong> Rapid adoption with 72% focusing on analytics
          </li>
          <li>
            <strong>Latin America:</strong> Infrastructure limitations create unique challenges
          </li>
          <li>
            <strong>North America:</strong> AI innovation leads with 51% improving AI support
          </li>
        </ul>,
        null
      ),
    strategicGoals: () =>
      renderModalShell(
        'Strategic Priority Benchmarks',
        "Here's how your priorities compare to industry averages:",
        renderBenchmarkStats(strategicGoalStats, (item) => formData?.strategicGoals?.includes(item.key))
      ),
    adoptionTrends: () =>
      renderModalShell(
        'Multicloud Drivers Analysis',
        '50% of enterprise application workloads now operate in multicloud or hybrid cloud setups. Organizations leverage these setups for diverse purposes:',
        renderBenchmarkStats(adoptionTrendStats)
      ),
    providers: () =>
      renderModalShell(
        'Industry Benchmark',
        `On average, organizations use ${averageProviderCount} cloud/SaaS providers. You indicated ${sliderValue} providers. Your selection helps us benchmark your complexity against industry standards.`,
        null
      ),
  };

  const renderModal = renderers[modalType] || renderers.providers;
  return (
    <div className={`benchmark-modal-wrapper${isOpen ? ' is-visible' : ''}`} aria-hidden={isOpen ? 'false' : 'true'}>
      {isOpen ? renderModal() : null}
    </div>
  );
};

export default BenchmarkModal;
